/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `theater` - Theater
 * * `arena` - Arena
 * * `amphitheater` - Amphitheater
 * * `club` - Club
 * * `hall` - Hall
 * * `outdoor` - Outdoor
 * * `other` - Other
 * @export
 */
export const VenueTypeEnum = {
    Theater: 'theater',
    Arena: 'arena',
    Amphitheater: 'amphitheater',
    Club: 'club',
    Hall: 'hall',
    Outdoor: 'outdoor',
    Other: 'other'
} as const;
export type VenueTypeEnum = typeof VenueTypeEnum[keyof typeof VenueTypeEnum];


export function instanceOfVenueTypeEnum(value: any): boolean {
    for (const key in VenueTypeEnum) {
        if (Object.prototype.hasOwnProperty.call(VenueTypeEnum, key)) {
            if (VenueTypeEnum[key as keyof typeof VenueTypeEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function VenueTypeEnumFromJSON(json: any): VenueTypeEnum {
    return VenueTypeEnumFromJSONTyped(json, false);
}

export function VenueTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): VenueTypeEnum {
    return json as VenueTypeEnum;
}

export function VenueTypeEnumToJSON(value?: VenueTypeEnum | null): any {
    return value as any;
}

export function VenueTypeEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): VenueTypeEnum {
    return value as VenueTypeEnum;
}

